import { Component, ViewChild } from "@angular/core";
import { IFloatingFilterComp } from "ag-grid-angular";
import { IFloatingFilterParams, FilterChangedEvent } from "ag-grid-community";
import { SystemService } from "src/app/service/system.service";

@Component({
  selector: "app-roles-floating-filter",
  templateUrl: "./roles-floating-filter.component.html",
  styleUrls: ["./roles-floating-filter.component.css"],
})
export class RolesFloatingFilter implements IFloatingFilterComp {
  public text: string; // need to be public for --prod compile
  private params: IFloatingFilterParams<any, any>;
  dropdownEnabled: boolean = false;
  selectAllChecked: boolean = false;
  public roles = [];
  systemRoles = [];
  // public roles = [
  //   { id: 'iap', value: 'IAP', checked: false},
  //   { id: 'time', value: 'Time', checked: false},
  //   { id: 'accountManager', value: 'Account Manager', checked: false},
  //   { id: 'checkin', value: 'Check-In / Demob', checked: false},
  //   { id: 'cost', value: 'Cost', checked: false},
  //   { id: 'dataSteward', value: 'Data Steward', checked: false},
  //   { id: 'helpDesk', value: 'Help Desk', checked: false},
  //   { id: 'globalReferenceDataManager', value: 'Global Reference Data Manager', checked: false},
  //   { id: 'geographicRatesManager', value: 'Geographic Rates Manager', checked: false},
  //   { id: 'dataManager', value: 'Data Manager', checked: false},
  //   { id: 'trainingSpecialist', value: 'Training Specialist', checked: false}
  // ];

  constructor(public systemService: SystemService) {}

  agInit(params: IFloatingFilterParams<any, any>): void {
    this.loadRoles();
    this.params = params;
    this.text = "";
  }

  updateCheckedOptions() {
    this.params.onFloatingFilterChanged(this.roles);
  }

  loadRoles() {
    this.roles = [];
    this.systemService.getSystemRoles().subscribe((data) => {
      if (data["courseOfActionVo"]["coaType"] === "HANDLE_RECORDSET") {
        this.systemRoles = data["recordset"] as any[];
        this.systemRoles.forEach((each) => {
          var role = {
            id: each.roleName,
            value: each.displayName,
            checked: false,
          };
          this.roles.push(role);
        });
      }
    });
  }

  selectAll(event) {
    this.selectAllChecked = event;
    this.roles.forEach((item) => (item.checked = this.selectAllChecked));
    this.updateCheckedOptions();
  }

  openDropdown() {
    if (!this.dropdownEnabled) {
      this.dropdownEnabled = true;
    } else {
      this.dropdownEnabled = false;
    }
  }

  onClick(event) {
    if (this.dropdownEnabled) {
      this.dropdownEnabled = false;
    }
  }

  onParentModelChanged(parentModel) {
    this.text = parentModel.value;
  }
}
